import { Tooltip } from "@mui/material";
import { GridRenderCellParamsPremium } from "@mui/x-data-grid-premium/typeOverloads";
import { GridApi, GridRenderCellParams, selectedIdsLookupSelector } from "@mui/x-data-grid-pro";
import { MutableRefObject } from "react";
import { Ico_AllSelected, Ico_NoneSelected } from "@sagecentral/core-ui";

const CheckboxIndicator = (apiRef: MutableRefObject<GridApi>, params: GridRenderCellParams & GridRenderCellParamsPremium): JSX.Element => {
    const { rowNode } = params;

    if (!apiRef.current.isRowSelectable(params.id) || rowNode.type !== "group")
        return <></>;

    const selectionLookup = selectedIdsLookupSelector(
        apiRef.current.state,
        apiRef.current.instanceId
    );

    const allSelectableChildren = apiRef.current.getRowGroupChildren({
        groupId: rowNode.id,
        applyFiltering: true,
        applySorting: true,
    })?.filter((child) => apiRef.current.isRowSelectable(child));

    if (allSelectableChildren === undefined || allSelectableChildren.length === 0)
        return <></>;

    const allChildrenChecked = allSelectableChildren?.every((child) => selectionLookup[child] !== undefined);

    const someChildrenChecked = allSelectableChildren?.some((child) => selectionLookup[child] === undefined) &&
        allSelectableChildren?.some((child) => selectionLookup[child] !== undefined);

    const [icon, toolTip] = allChildrenChecked ? [<Ico_AllSelected />, "All children are selected"] :
        someChildrenChecked ? [<Ico_NoneSelected />, "Some children are selected"] : [];

    if (icon !== undefined)
        return <>
            <Tooltip title={toolTip}>
                {icon}
            </Tooltip>
        </>
    else
        return <></>
}

export default CheckboxIndicator;